import { exists } from '@/api'
import dayjs from 'dayjs'

export interface BatchSchoolStatisticsConditionListItem {
  lendDateFrom: string
  lendDateTo: string
  lendTitle: string
  lendType: string[]
  lendBranchCodeFrom: string
  lendBranchCodeTo: string
  placeCodeFrom: string
  placeCodeTo: string
  gradeFrom: string
  gradeTo: string
  classForm: string
  classTo: string
  userIdFrom: string
  userIdTo: string
  interlibraryLoanCodeFrom: string
  interlibraryLoanCodeTo: string
  yearAgeEnabled: boolean
  xItem: string
  yItem1: string
  yCheck1: boolean[]
  yItem2: string
  yCheck2: boolean[]
  yItem3: string
  yCheck3: boolean[]
  yItem4: string
  yCheck4: boolean[]
  bookCount: boolean
  personCount: boolean
  actualPersonCount: boolean
  displayFullName: boolean
  lendMemo: string
  batchType: string
}

export function BatchSchoolStatisticsConditionListItemFromJSON(
  json: any
): BatchSchoolStatisticsConditionListItem {
  const resp = JSON.parse(json)

  return {
    lendDateFrom: exists(resp, 'lend_date_from')
      ? resp.lend_date_from
      : dayjs()
          .add(-1, 'month')
          .format('YYYYMMDD'),
    lendDateTo: exists(resp, 'lend_date_to')
      ? resp.lend_date_to
      : dayjs().format('YYYYMMDD'),
    lendTitle: exists(resp, 'title') ? resp.title : '',
    lendType: exists(resp, 'lend_type') ? resp.lend_type : ['0', '0'],
    lendBranchCodeFrom: exists(resp, 'lend_branch_code_from')
      ? resp.lend_branch_code_from
      : '',
    lendBranchCodeTo: exists(resp, 'lend_branch_code_to')
      ? resp.lend_branch_code_to
      : '',
    placeCodeFrom: exists(resp, 'place_code_from') ? resp.place_code_from : '',
    placeCodeTo: exists(resp, 'place_code_to') ? resp.place_code_to : '',
    gradeFrom:
      exists(resp, 'grade_from') && resp.grade_from !== ''
        ? resp.grade_from
        : null,
    gradeTo:
      exists(resp, 'grade_to') && resp.grade_to !== '' ? resp.grade_to : null,
    classForm:
      exists(resp, 'class_from') && resp.class_from !== ''
        ? resp.class_from
        : null,
    classTo:
      exists(resp, 'class_to') && resp.class_to !== '' ? resp.class_to : null,
    userIdFrom: exists(resp, 'user_id_from') ? resp.user_id_from : '',
    userIdTo: exists(resp, 'user_id_to') ? resp.user_id_to : '',
    interlibraryLoanCodeFrom: exists(resp, 'interlibrary_loan_code_from')
      ? resp.interlibrary_loan_code_from
      : '',
    interlibraryLoanCodeTo: exists(resp, 'interlibrary_loan_code_to')
      ? resp.interlibrary_loan_code_to
      : '',
    yearAgeEnabled: exists(resp, 'year_age_enabled')
      ? resp.year_age_enabled
      : false,
    xItem: resp.x_item,
    yItem1: resp.y_item1,
    yCheck1: exists(resp, 'y_check1') ? resp.y_check1 : [false, false],
    yItem2: exists(resp, 'y_item2') ? resp.y_item2 : '',
    yCheck2: exists(resp, 'y_check2') ? resp.y_check2 : [false, false],
    yItem3: exists(resp, 'y_item2') ? resp.y_item3 : '',
    yCheck3: exists(resp, 'y_check3') ? resp.y_check3 : [false, false],
    yItem4: exists(resp, 'y_item2') ? resp.y_item4 : '',
    yCheck4: exists(resp, 'y_check4') ? resp.y_check4 : [false, false],
    bookCount: exists(resp, 'book_count') ? resp.book_count : false,
    personCount: exists(resp, 'person_count') ? resp.person_count : false,
    actualPersonCount: exists(resp, 'actual_person_count')
      ? resp.actual_person_count
      : false,
    displayFullName: exists(resp, 'display_full_name')
      ? resp.display_full_name
      : false,
    lendMemo: resp.memo,
    batchType: resp.batch_type
  }
}
